<template>
  <section class="cta py-6 bg-gradient-primary text-white position-relative overflow-hidden">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <h2 class="display-4 fw-bold mb-4">
            Pronto a Semplificare la Tua Gestione?
          </h2>
          <p class="lead mb-5">
            Scopri come il nostro software può ottimizzare la tua attività.
            Richiedi una demo personalizzata e gratuita.
          </p>
          <div class="d-flex gap-3 justify-content-center">
            <button class="btn btn-light btn-lg px-5">
              <i class="bi bi-calendar-check me-2"></i>
              Richiedi Demo
            </button>
            <button class="btn btn-outline-light btn-lg px-5">
              <i class="bi bi-download me-2"></i>
              Scarica Brochure
            </button>
          </div>

          <!-- Stats -->
          <div class="row g-4 mt-5">
            <div class="col-md-4">
              <div class="stat p-4 rounded-4 bg-white bg-opacity-10">
                <h3 class="fw-bold mb-1">100%</h3>
                <p class="mb-0">Personalizzabile</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="stat p-4 rounded-4 bg-white bg-opacity-10">
                <h3 class="fw-bold mb-1">24/7</h3>
                <p class="mb-0">Supporto Tecnico</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="stat p-4 rounded-4 bg-white bg-opacity-10">
                <h3 class="fw-bold mb-1">2in1</h3>
                <p class="mb-0">Auto + Immobili</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Decorative elements -->
    <div class="position-absolute top-50 start-0 translate-middle-y">
      <svg width="400" height="400" viewBox="0 0 400 400" fill="none">
        <circle cx="200" cy="200" r="200" fill="rgba(255,255,255,0.1)"/>
      </svg>
    </div>
    <div class="position-absolute top-0 end-0">
      <svg width="300" height="300" viewBox="0 0 300 300" fill="none">
        <circle cx="150" cy="150" r="150" fill="rgba(255,255,255,0.05)"/>
      </svg>
    </div>
  </section>
</template>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, var(--bs-primary) 0%, #1e40af 100%);
}

.cta {
  background: #219ebc !important; /* Azzurro medio */
  color: #fff;
}

.btn-light {
  background: #ffb703 !important; /* Giallo */
  color: #023047 !important; /* Blu scuro */
  border: none;
}

.btn-light:hover {
  background: #fb8500 !important; /* Arancione */
  color: #023047 !important;
}

.btn-outline-light:hover {
  background: #8ecae6 !important; /* Azzurro chiaro */
  color: #023047 !important;
}

.stat {
  background: rgba(142, 202, 230, 0.1) !important; /* Azzurro chiaro con opacità */
  transition: transform 0.3s ease;
}

.stat:hover {
  transform: translateY(-5px);
}
</style>
